import React from 'react';

import EmarsysZone from 'coreComponents/EmarsysZone';

import styles from './EmarsysZones.module.scss';

const EmarsysZones = (): React.ReactElement => {
	return (
		<>
			<div className={styles['fixed-bottom-bar']}>
				<EmarsysZone id="bottom-banner" />
			</div>
			<div className={styles['fixed-bottom-left-window']}>
				<EmarsysZone id="bottom-left-window" />
			</div>
			<div className={styles['fixed-bottom-right-window']}>
				<EmarsysZone id="bottom-right-window" />
			</div>
			<div className={styles['fixed-centered-window']}>
				<EmarsysZone id="centered-window" />
			</div>
		</>
	);
};

export default EmarsysZones;
